// @ts-nocheck

import React, { useState, useEffect, useRef } from 'react'
import styled from 'styled-components'
import TvlK from '../../components/Charts/TvlK'
import VolumeK from '../../components/Charts/VolumeK'
import thousandsSeparator from '../../utils/thousandsSeparator';

const Wrap = styled.div`
  display: flex;
  justify-content: space-between;
  /* background: #fff; */
  gap: 14px;
  .box {
    padding: 20px;
    padding-top: 10px;
    width: 50%;
    /* background: rgba(197, 197, 197, 0.18); */
    /* border: 1px solid #000; */
    /* backdrop-filter: blur(13px); */
    background: #fff;
    /* border-radius: 20px; */

    .title {
      color: #7d7d7d;
      display: none;
    }

    .data {
      margin-top: 20px;
      color: '#000';
      font-size: 30px;
      font-weight: 500;
      display: none;
    }

    .img {
      width: 100%;

      /* height: 400px; */
      img {
        width: 100%;
      }
    }
  }
  @media (max-width: 768px) {
    .box {
      width: 48%;
      /* height: 110px; */
      /* background: #f9f9f9; */
      background: #FFF;
      padding: 20px;
      /* display: none; */
      .title {
        font-size: 14px;
        display: block;
      }
      .data {
        margin-top: 8px;
        display: block;
        font-family: 600;
        font-size: 20px;
      }
    }
    .img {
      display: none;
    }
  }
`

export default function Line() {
  const [leftData, setData] = useState(0)
  const [rightData, setRightData] = useState(0)

  function getData(data: any) {
    // console.log(data);
    setData(data)
  }

  function getRightData(data: any) {
    // console.log(data);
    setRightData(data)
  }

  return (
    <Wrap>
      <div className="box">
        <div className="title">DovraSwap TVL</div>
        <div className="data">¥{thousandsSeparator(leftData)}</div>
        <div className="img">
          <TvlK onData={getData}></TvlK>
        </div>
      </div>
      <div className="box">
        <div className="title">DovraSwap volume</div>
        <div className="data">¥{thousandsSeparator(rightData)}</div>
        <div className="img">
          <VolumeK onData={getRightData} />
        </div>
        {/* <TvlK></TvlK> */}
      </div>
    </Wrap>
  )
}
